module.exports = __webpack_public_path__ + "static/media/newslettersIcon.c40ecc07.png";